import Hero from './Components/Hero';
import Navbar from './Components/Navbar';
import About from './Components/About';
import Tours from './Components/Tours';
import Services from './Components/Services';
import Footer from './Components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Tours />
      <Footer />
    </>
  );
}

export default App;
